<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="end font font-weight-bold white b-right" colspan="2">Goodwill</td>
                            <td class=" end font font-weight-bold white b-right">Licences and
                                <br/>spectrum fees</td>
                            <td class=" end font font-weight-bold white b-right">Others</td>
                            <td class="end font font-weight-bold white b-right">Total</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td class="center white font-weight-bold font" colspan="2">KD ’000</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="skyBlue font" colspan="5">Cost</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2018</td>
                            <td class="end font white font-weight-bold">621,063</td>
                            <td class="end font white font-weight-bold">2,581,610</td>
                            <td class="end font white font-weight-bold">204,466</td>
                            <td class="end font white font-weight-bold">3,407,139</td>
                        </tr>
                        <tr>
                            <td class="font">Adjustment on Purchase price allocation </td>
                            <td class="end font">(12,193)</td>
                            <td class="end font">-</td>
                            <td class="end font">41,144</td>
                            <td class="end font">28,951</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2018 (Restated)</td>
                            <td class="end font white font-weight-bold">608,870</td>
                            <td class="end font white font-weight-bold">2,581,610</td>
                            <td class="end font white font-weight-bold">245,610</td>
                            <td class="end font white font-weight-bold">3,436,090</td>
                        </tr>
                        <tr>
                            <td class="font">On acquisition of subsidiaries</td>
                            <td class="end font">16,623</td>
                            <td class="end font">-</td>
                            <td class="end font">-</td>
                            <td class="end font">16,623</td>
                        </tr>
                        <tr>
                            <td class="font">Additions</td>
                            <td class="end font">-</td>
                            <td class="end font">59,340</td>
                            <td class="end font">9,520</td>
                            <td class="end font">68,860</td>
                        </tr>
                        <tr>
                            <td class="font">Write off</td>
                            <td class="end font">-</td>
                            <td class="end font">(9,869)</td>
                            <td class="end font">(706)</td>
                            <td class="end font">(10,575)</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustments</td>
                            <td class="end font">1,012</td>
                            <td class="end font">(1,831)</td>
                            <td class="end font">417</td>
                            <td class="end font">(402)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2019</td>
                            <td class="end font white font-weight-bold">626,505</td>
                            <td class="end font white font-weight-bold">2,629,250</td>
                            <td class="end font white font-weight-bold">254,841</td>
                            <td class="end font white font-weight-bold">3,510,596</td>
                        </tr>
                        <tr>
                            <td class="font">Additions</td>
                            <td class="end font">-</td>
                            <td class="end font">81,930</td>
                            <td class="end font">21,179</td>
                            <td class="end font">103,109</td>
                        </tr>
                        <tr>
                            <td class="font">Transfers</td>
                            <td class="end font">-</td>
                            <td class="end font"> 162</td>
                            <td class="end font">215</td>
                            <td class="end font">377</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustments</td>
                            <td class="end font"> (2,349)</td>
                            <td class="end font"> 2,480</td>
                            <td class="end font">(591)</td>
                            <td class="end font">(460)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2020</td>
                            <td class="end font white font-weight-bold">624,156</td>
                            <td class="end font white font-weight-bold">2,713,822 </td>
                            <td class="end font white font-weight-bold">275,644</td>
                            <td class="end font white font-weight-bold">3,613,622</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">Accumulated amortization/ Impairment</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2018</td>
                            <td class="end font white font-weight-bold">11,942</td>
                            <td class="end font white font-weight-bold">1,131,958</td>
                            <td class="end font white font-weight-bold">99,972</td>
                            <td class="end font white font-weight-bold">1,243,872</td>
                        </tr>
                        <tr>
                            <td class="font">Charge for the year</td>
                            <td class="end font">-</td>
                            <td class="end font">95,516</td>
                            <td class="end font">23,151</td>
                            <td class="end font">118,667</td>
                        </tr>
                        <tr>
                            <td class="font">On Write off</td>
                            <td class="end font">-</td>
                            <td class="end font">(8,444)</td>
                            <td class="end font">(566)</td>
                            <td class="end font">(9,010)</td>
                        </tr>
                        <tr>
                            <td class="font">Impairment</td>
                            <td class="end font">6,752</td>
                            <td class="end font">-</td>
                            <td class="end font">-</td>
                            <td class="end font">6,752</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustments</td>
                            <td class="end font">-</td>
                            <td class="end font">(989) </td>
                            <td class="end font">(8,735)</td>
                            <td class="end font">(9,724)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2019</td>
                            <td class="end font white font-weight-bold">18,694</td>
                            <td class="end font white font-weight-bold">1,218,041</td>
                            <td class="end font white font-weight-bold">113,822</td>
                            <td class="end font white font-weight-bold">1,350,557</td>
                        </tr>
                        <tr>
                            <td class="font">Charge for the year</td>
                            <td class="end font"><span class="invisible">asdf</span></td>
                            <td class="end font">75,571</td>
                            <td class="end font">19,534</td>
                            <td class="end font">95,105</td>
                        </tr>
                        <tr>
                            <td class="font">Exchange adjustments</td>
                            <td class="end font">-</td>
                            <td class="end font">544</td>
                            <td class="end font">(120)</td>
                            <td class="end font">424</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2020</td>
                            <td class="end font white font-weight-bold">18,694</td>
                            <td class="end font white font-weight-bold">1,294,156</td>
                            <td class="end font white font-weight-bold">133,236</td>
                            <td class="end font white font-weight-bold">1,446,086</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">Net book value</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2020</td>
                            <td class="end font white font-weight-bold">605,462</td>
                            <td class="end font white font-weight-bold">1,419,666</td>
                            <td class="end font white font-weight-bold">142,408</td>
                            <td class="end font white font-weight-bold">2,167,536</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">As at 31 December 2019</td>
                            <td class="end font white font-weight-bold">607,811</td>
                            <td class="end font white font-weight-bold">1,411,209</td>
                            <td class="end font white font-weight-bold">141,019</td>
                            <td class="end font white font-weight-bold">2,160,039</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="end font font-weight-bold white b-right" colspan="2">شهرة</td>
                            <td class=" end font font-weight-bold white b-right">رسوم التراخيص 
                                <br/>والطيف الترددي</td>
                            <td class=" end font font-weight-bold white b-right">أخرى</td>
                            <td class="end font font-weight-bold white b-right">المجموع</td>
                        </tr>
                        <tr class="med-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td class="center white font-weight-bold font" colspan="2">ألف دينار كويتي</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="skyBlue font" colspan="5">التكلفة</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2018</td>
                            <td class="end font white font-weight-bold">621,063</td>
                            <td class="end font white font-weight-bold">2,581,610</td>
                            <td class="end font white font-weight-bold">204,466</td>
                            <td class="end font white font-weight-bold">3,407,139</td>
                        </tr>
                        <tr>
                            <td class="font">تسوية نتيجة توزيع سعر الشراء</td>
                            <td class="end font">(12,193)</td>
                            <td class="end font">-</td>
                            <td class="end font">41,144</td>
                            <td class="end font">28,951</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">الرصيد كما في 31 ديسمبر 2018 (معدل)</td>
                            <td class="end font white font-weight-bold">608,870</td>
                            <td class="end font white font-weight-bold">2,581,610</td>
                            <td class="end font white font-weight-bold">245,610</td>
                            <td class="end font white font-weight-bold">3,436,090</td>
                        </tr>
                        <tr>
                            <td class="font">نتيجة الاستحواذ على شركات تابعة</td>
                            <td class="end font">16,623</td>
                            <td class="end font">-</td>
                            <td class="end font">-</td>
                            <td class="end font">16,623</td>
                        </tr>
                        <tr>
                            <td class="font">إضافات</td>
                            <td class="end font">-</td>
                            <td class="end font">59,340</td>
                            <td class="end font">9,520</td>
                            <td class="end font">68,860</td>
                        </tr>
                        <tr>
                            <td class="font">مشطوبات</td>
                            <td class="end font">-</td>
                            <td class="end font">(9,869)</td>
                            <td class="end font">(706)</td>
                            <td class="end font">(10,575)</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">1,012</td>
                            <td class="end font">(1,831)</td>
                            <td class="end font">417</td>
                            <td class="end font">(402)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2019</td>
                            <td class="end font white font-weight-bold">626,505</td>
                            <td class="end font white font-weight-bold">2,629,250</td>
                            <td class="end font white font-weight-bold">254,841</td>
                            <td class="end font white font-weight-bold">3,510,596</td>
                        </tr>
                        <tr>
                            <td class="font">إضافات</td>
                            <td class="end font">-</td>
                            <td class="end font">81,930</td>
                            <td class="end font">21,179</td>
                            <td class="end font">103,109</td>
                        </tr>
                        <tr>
                            <td class="font">تحويلات</td>
                            <td class="end font">-</td>
                            <td class="end font"> 162</td>
                            <td class="end font">215</td>
                            <td class="end font">377</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font"> (2,349)</td>
                            <td class="end font"> 2,480</td>
                            <td class="end font">(591)</td>
                            <td class="end font">(460)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2020</td>
                            <td class="end font white font-weight-bold">624,156</td>
                            <td class="end font white font-weight-bold">2,713,822 </td>
                            <td class="end font white font-weight-bold">275,644</td>
                            <td class="end font white font-weight-bold">3,613,622</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">الإطفاءات المتراكمة / الانخفاض في القيمة</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2018</td>
                            <td class="end font white font-weight-bold">11,942</td>
                            <td class="end font white font-weight-bold">1,131,958</td>
                            <td class="end font white font-weight-bold">99,972</td>
                            <td class="end font white font-weight-bold">1,243,872</td>
                        </tr>
                        <tr>
                            <td class="font">المحمل على السنة</td>
                            <td class="end font">-</td>
                            <td class="end font">95,516</td>
                            <td class="end font">23,151</td>
                            <td class="end font">118,667</td>
                        </tr>
                        <tr>
                            <td class="font">نتيجة المشطوبات</td>
                            <td class="end font">-</td>
                            <td class="end font">(8,444)</td>
                            <td class="end font">(566)</td>
                            <td class="end font">(9,010)</td>
                        </tr>
                        <tr>
                            <td class="font">انخفاض القيمة</td>
                            <td class="end font">6,752</td>
                            <td class="end font">-</td>
                            <td class="end font">-</td>
                            <td class="end font">6,752</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">-</td>
                            <td class="end font">(989) </td>
                            <td class="end font">(8,735)</td>
                            <td class="end font">(9,724)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2019</td>
                            <td class="end font white font-weight-bold">18,694</td>
                            <td class="end font white font-weight-bold">1,218,041</td>
                            <td class="end font white font-weight-bold">113,822</td>
                            <td class="end font white font-weight-bold">1,350,557</td>
                        </tr>
                        <tr>
                            <td class="font">المحمل على السنة</td>
                            <td class="end font"><span class="invisible">asdf</span></td>
                            <td class="end font">75,571</td>
                            <td class="end font">19,534</td>
                            <td class="end font">95,105</td>
                        </tr>
                        <tr>
                            <td class="font">تعديلات صرف عملات أجنبية</td>
                            <td class="end font">-</td>
                            <td class="end font">544</td>
                            <td class="end font">(120)</td>
                            <td class="end font">424</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2020</td>
                            <td class="end font white font-weight-bold">18,694</td>
                            <td class="end font white font-weight-bold">1,294,156</td>
                            <td class="end font white font-weight-bold">133,236</td>
                            <td class="end font white font-weight-bold">1,446,086</td>
                        </tr>
                        <tr>
                            <td class="skyBlue font" colspan="5">صافي القيمة الدفترية</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2020</td>
                            <td class="end font white font-weight-bold">605,462</td>
                            <td class="end font white font-weight-bold">1,419,666</td>
                            <td class="end font white font-weight-bold">142,408</td>
                            <td class="end font white font-weight-bold">2,167,536</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font white font-weight-bold">كما في 31 ديسمبر 2019</td>
                            <td class="end font white font-weight-bold">607,811</td>
                            <td class="end font white font-weight-bold">1,411,209</td>
                            <td class="end font white font-weight-bold">141,019</td>
                            <td class="end font white font-weight-bold">2,160,039</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>